var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.59722C0 1.16282 1.16282 0 2.59722 0H12.0081C12.8222 0 13.6029 0.323387 14.1786 0.899017L16.101 2.82147C16.6766 3.3971 17 4.17783 17 4.99189V14.4028C17 15.8372 15.8372 17 14.4028 17H2.59722C1.16282 17 0 15.8372 0 14.4028V2.59722ZM2.59722 1.41667C1.94522 1.41667 1.41667 1.94522 1.41667 2.59722V14.4028C1.41667 15.0548 1.94522 15.5833 2.59722 15.5833H2.83333V10.625C2.83333 9.45143 3.78473 8.5 4.95833 8.5H12.0417C13.2152 8.5 14.1667 9.45143 14.1667 10.625V15.5833H14.4028C15.0548 15.5833 15.5833 15.0548 15.5833 14.4028V4.99189C15.5833 4.55354 15.4092 4.13316 15.0992 3.82321L13.1768 1.90075C12.9311 1.6551 12.6161 1.49476 12.2778 1.4388V4.01389C12.2778 5.18749 11.3263 6.13889 10.1528 6.13889H5.90278C4.72917 6.13889 3.77778 5.18749 3.77778 4.01389V1.41667H2.59722ZM12.75 15.5833V10.625C12.75 10.2338 12.4329 9.91667 12.0417 9.91667H4.95833C4.56713 9.91667 4.25 10.2338 4.25 10.625V15.5833H12.75ZM5.19444 1.41667V4.01389C5.19444 4.40509 5.51158 4.72222 5.90278 4.72222H10.1528C10.544 4.72222 10.8611 4.40509 10.8611 4.01389V1.41667H5.19444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.82cc542d9cb46223cf7bac07473f3b7e.svg";
export { ForwardRef as ReactComponent };